// removed by extract-text-webpack-plugin
module.exports = {"chevron":"chevron___3zl_D","brand":"brand____1dOl","primary":"primary___26RGZ","terciary":"terciary___2kogH","negative":"negative___3YqZV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Chevron/index.scss
// module id = 79
// module chunks = 0